import { environment } from 'src/environment';
import { Component, OnInit, Inject, OnDestroy, HostListener } from '@angular/core';
import { BaseService, SettingsService, StorageService } from 'src/app/core/services';
import { Router } from '@angular/router';
import { SearchService } from 'src/app/core/services/search.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { NgClass, NgIf } from '@angular/common';
import { CardListComponent } from '../card-list/card-list.component';
import { SlickItemComponent } from '../slick-item/slick-item.component';
import { InhouseAnalyticsService } from 'src/app/core/services/inhouse-analytics.service';
export interface DialogData {
  return;
}

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss', './search.component.scss'],
  standalone: true,
  imports: [NgIf, NgClass, LottieComponent, CardListComponent, SlickItemComponent]
})
export class SearchComponent implements OnInit, OnDestroy {
  slideToShow: number;
  slideToScroll: number;
  slideToShowSeries: number;
  slideToScrollSeries: number;
  windowWidth: number;
  searchKey;
  searchActive: boolean;
  data: any[];
  audioData;
  articleData;
  videoData:any[];
  searchCount;
  noResultsMessage: string;
  audioNoResultMessage:string;
  searchOpenedFirst = true;
  imagePath: any;
  searchName;
  numCardsInRow;
  searchData = [];
  audioSearchData = [];
  articleSearchData = [];
  searchSlickData = {};
  audioSlickData = {};
  articleSlickData = {};
  tagsLength;
  showMoreResult = false;
  showLessButton = false;
  showAudioMoreResult = false;
  showAudioLessButton = false;
  showArticleMoreResult = false;
  showArticleLessButton = false;
  options: AnimationOptions = {
    path: `branding/assets/search-loader.json`
  };
  overrideLoader = false;
  takeValue: number;
  paginate = false;
  search_count = 0;
  audio_search_count = 0;
  article_search_count = 0;
  skip = 0;
  audioSkip = 0;
  articleSkip = 0;
  tempData = [];
  audioTempData = [];
  articleTempData = [];
  totalGetCount = 0;
  totalAudioGetCount = 0;
  totalArticleGetCount = 0;
  dynamicName = '';
  searchSubscriber;
  videoTitle = "";
  audioTitle = '';
  articleTitle = '';
  videoSlickOrientation = 0;
  audioSlickOrientation = 3;
  articleSlickOrientation = 1;
  skinName = environment.skinName;
  purchases: any;
  audioSupported = false;
  articleSupported = false;
  all = true;
  AudioSelet = false;
  videos = false;
  selectedTab = ''
  searchOptions = ['All','Videos'];
  videoSearchCount = 0;
  audioSearchCount = 0;
  articleSearchCount = 0;


  constructor(public settingsService: SettingsService, private router: Router,
    private searchService: SearchService, public dialogRef: MatDialogRef<SearchComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: DialogData, public configService: ConfigurationService,
    private baseService: BaseService, private storageService: StorageService, private analyticsService: InhouseAnalyticsService) {
    this.takeValue = this.settingsService.takeValue || 12;
    if(this.settingsService.audioSupported) this.audioSupported = true;
    else this.audioSupported = false;
    if(this.settingsService.articleSupported) this.articleSupported = true;
    else this.articleSupported = false;
  }

  ngOnInit(): void {
    const eventObj = {
      event_type: 'Page View',
      event_name: 'Search Page View',
      event_status: 'Success',
    };
    this.analyticsService.trackUserActions(eventObj);

    this.selectedTab = this.searchOptions[0];
    this.settingsService.showHeader = true;
    this.settingsService.showFooter = false;
    this.purchases = this.storageService.getLocalStore('userPurchases');
    const headerTop = <HTMLInputElement>document.querySelector(".navbar");
    headerTop.style.position = 'fixed';
    headerTop.style.marginRight = '18px';
    this.imagePath = this.settingsService.imagePath;
    this.windowWidth = window.innerWidth;
    this.setNumCards();
    this.searchSubscriber = this.baseService.searchData.subscribe(search => {
      this.searchName = search;
      this.getSearchData(this.searchName, 0, this.takeValue, "searchdata", false);
    });
    document.getElementById("inputSearch").focus();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setNumCards();
  }

  // this method using divided base on the movie grids
  setNumCards() {
    const windowWidth: number = window.innerWidth;
    this.numCardsInRow = Math.floor((windowWidth - ((169 * 2) - 98)) / (302 + 98));
  }

  // this method using to close the search text
  closeSearch() {
    this.searchActive = false;
    this.data = [];
    this.audioData = {};
    this.articleData = {}
    this.searchCount = '';
    this.videoSearchCount = 0;
    this.audioSearchCount = 0;
    this.articleSearchCount = 0;
    this.totalGetCount = 0;
    this.totalAudioGetCount = 0;
    this.totalArticleGetCount = 0;
    this.dynamicName = '';
    this.searchKey = undefined;
    this.noResultsMessage = '';
    this.audioNoResultMessage = '';
    this.dialogRef.close();
    this.settingsService.showFooter = true;
  }

  // this method for get the search text details
  getSearchData(key, skip, take, type, more) {
    if(type == 'searchdata'){
      if (this.dynamicName == '') this.dynamicName = key;
      else if (this.dynamicName != key){
        this.totalGetCount = 0;
        this.totalAudioGetCount = 0;
        this.totalArticleGetCount = 0;
      }
    }
    const headerTop = <HTMLInputElement>document.querySelector(".navbar");
    headerTop.style.zIndex = '1047';
    this.searchOpenedFirst = false;
    if(more)this.paginate = true;
    else this.overrideLoader = true;
    this.searchService.getData(key, skip, take).subscribe(
      (data) => {
        if (data) {
          this.paginate = false;
          this.data = data.contents;
          this.data.forEach(content =>{
            if(content.key == 'video') {
              this.data[0] = content;
              this.videoTitle = content.title;
              this.videoSlickOrientation = +content.orientation;
              this.videoSearchCount = content.count;
              return;
            }
            if(content.key == 'audio') {
              this.audioData = content;
              this.audioTitle = content.title;
              this.audioSlickOrientation = 3;
              this.audioSearchCount = content.count;
              return;
            }
            if(content.key == 'article') {
              this.articleData = content;
              this.articleTitle = content.title;
              this.audioSlickOrientation = 1;
              this.articleSearchCount = content.count;
              return;
            }
          })
          this.searchCount = data.total;
          this.search_count = this.data[0].list.length;
          this.audio_search_count = this.audioData?.list?.length;
          this.article_search_count =  this.articleData?.list?.length;
          this.totalGetCount += this.data[0].list.length;
          this.totalAudioGetCount += this.audioData?.list?.length;
          this.totalArticleGetCount += this.articleData?.list?.length;
          if(this.totalAudioGetCount > 0 && !this.searchOptions.includes('Audios')) this.searchOptions.push('Audios');
          if(this.totalArticleGetCount > 0 && !this.searchOptions.includes('Article')) this.searchOptions.push('Article');
          this.overrideLoader = false;
          if (this.search_count > 0) {
            if (this.skip == 0) {
              this.searchData = this.data[0].list;
              Object.assign(this.searchSlickData , {list:this.searchData, orientation:this.videoSlickOrientation, component:'collection_widget'});
            } else {
              this.tempData = this.searchData;
              this.tempData = this.removeDupliactes(this.tempData.concat(this.data[0].list));
              this.searchData = this.tempData;
              Object.assign(this.searchSlickData , {list:this.searchData, orientation:this.videoSlickOrientation, component:'collection_widget'});
            }
          }
          if(this.audio_search_count > 0){
            if(this.audioSkip == 0){
              this.audioSearchData = this.audioData?.list;
              Object.assign(this.audioSlickData , {list:this.audioSearchData, orientation:3,key:'audio', component:'collection_widget'});
            }else{
              this.audioTempData = this.audioSearchData;
              this.audioTempData = this.removeDupliactes(this.audioTempData.concat(this.audioData?.list));
              this.audioSearchData = this.audioTempData;
              Object.assign(this.audioSlickData , {list:this.audioSearchData, orientation:3,key:'audio',  component:'collection_widget'});
            }
          }
          if(this.article_search_count > 0){
            if(this.articleSkip == 0){
              this.articleSearchData = this.articleData?.list;
              Object.assign(this.articleSlickData , {list:this.articleSearchData, orientation:1,key:'article', component:'collection_widget'});
            }else{
              this.articleTempData = this.articleSearchData;
              this.articleTempData = this.removeDupliactes(this.articleTempData.concat(this.articleData?.list));
              this.articleSearchData = this.articleTempData;
              Object.assign(this.articleSlickData , {list:this.articleSearchData, orientation:1,key:'article',  component:'collection_widget'});
            }
          }
          this.searchData.map(data => {
            if (data.tags && typeof (data.tags) == 'string') {
              this.tagsLength = data.tags.length;
              return data.tags = data.tags.split(',');
            }
          });
          this.audioSearchData.map(data =>{
            if (data.tags && typeof (data.tags) == 'string') {
              this.tagsLength = data.tags.length;
              return data.tags = data.tags.split(',');
            }
          })
          this.articleSearchData.map(data =>{
            if (data.tags && typeof (data.tags) == 'string') {
              this.tagsLength = data.tags.length;
              return data.tags = data.tags.split(',');
            }
          })
          if (this.searchCount === 0 && this.totalGetCount === 0) {
            this.noResultsMessage = 'No search results Found';
          }
          if(this.searchCount === 0 && this.totalAudioGetCount === 0 && this.totalArticleGetCount === 0) this.audioNoResultMessage = 'No search results Found';
          if ((this.skip + this.search_count) >= this.videoSearchCount) {
            this.showLessButton = true;
            this.showMoreResult = false;
          } else {
            this.showLessButton = false;
            this.showMoreResult = true;
          }
          if ((this.audioSkip + this.audio_search_count) >= this.audioSearchCount) {
            this.showAudioLessButton = true;
            this.showAudioMoreResult = false;
          } else {
            this.showAudioLessButton = false;
            this.showAudioMoreResult = true;
          }
          if ((this.articleSkip + this.article_search_count) >= this.articleSearchCount) {
            this.showArticleLessButton = true;
            this.showArticleMoreResult = false;
          } else {
            this.showArticleLessButton = false;
            this.showArticleMoreResult = true;
          }
        }
      }
    );
  }

  getClassForData(data){
    switch (data.component) {
      case 'livechannel_widget':
        return 'post-l-h';
      case 'continue_watching_widget':
        return data.orientation === 2 ? 'post-cw-h' : 'post-cw-h-two';
      case 'my_list_widget':
        return data.orientation === 1 ? 'post-ml-h-two' : 'post-h';
      case 'collection_widget':
      case 'top_picks_for_you_widget':
      case 'because_you_watched_widget':
      case 'my_purchases_widget':
        return data.orientation === 1 ? 'post-col-h-two' : 'post-h';
      case 'group_collection_widget':
      case 'content_partner_widget':
        return 'post-gc-h';
      case 'top_in_region_widget':
        return 'post-reg-h';
      default:
        return 'post-h';
    }
  }

  // this method using to search content details.
  goToSearchPage = function (term) {
    if (term) {
      this.searchService.getData(term).subscribe(
        (data) => {
          if (data) {
            this.data = data.contents;
            this.searchCount = data.total;
            if (this.searchCount === 0) {
              this.noResultsMessage = 'No search results Found';
            }
          }
        }
      );
    }
  };

  // this method using to if click more botton it's display the more related movie grides.
  openMore() {
    this.skip = this.search_count + this.skip;
    this.getSearchData(this.searchName, this.skip, this.takeValue, "loaddata", true);
  }

  openMoreAudio(){
    this.audioSkip = this.audio_search_count + this.audioSkip;
    this.getSearchData(this.searchName, this.audioSkip, this.takeValue, "loaddata", true);
  }

  openMoreArticle(){
    this.articleSkip = this.article_search_count + this.articleSkip;
    this.getSearchData(this.searchName, this.articleSkip, this.takeValue, "loaddata", true);
  }

  showLess() {
    this.showLessButton = false;
    this.searchData = this.searchData.slice(0, 6);
  }

  ngOnDestroy() {
    if(this.searchSubscriber) this.searchSubscriber.unsubscribe();
    const headerTop = <HTMLInputElement>document.querySelector(".navbar");
    headerTop.style.position = 'fixed';
    headerTop.style.marginRight = '0px';
    headerTop.style.zIndex = '1043';
    this.closeSearch();
  }

  // this method for removing duplicate for content list details 
  removeDupliactes(values) {
    let concatArray = values.map(eachValue => {
      return Object.values(eachValue).join('')
    })
    let filterValues = values.filter((value, index) => {
      return concatArray.indexOf(concatArray[index]) === index
    })
    return filterValues
  }

  selectTab(type){
    this.selectedTab = type;
  }
}
